import React from 'react';
import FilterContent from '../FilterContent';
import type { FeedbackFilterOption, FeedbackFilterParams } from '../index';
import type { FeedbackProductCategory, FeedbackProductItem, FetchProductsParams } from '@components/feedbackProductPicker';
import type { FeedbackProblemCategory, FeedbackProblemItem } from '@components/feedbackProblemPicker';

interface PCFeedbackFilterProps {
    filterParams: FeedbackFilterParams;
    searchInputValue: string;
    solveStateList: FeedbackFilterOption[];
    problemList: FeedbackFilterOption[];
    problemCategories: FeedbackProblemCategory[];
    productList: FeedbackFilterOption[];
    productCategories: FeedbackProductCategory[];
    daysList: FeedbackFilterOption[];
    totalCount?: number;
    layoutStyles?: Record<string, string>;
    onSearchChange?: (value: string) => void;
    onSearchConfirm?: () => void;
    onFilterChange?: (key: keyof FeedbackFilterParams, value: string) => void;
    onProblemSelect?: (problem: FeedbackProblemItem | null) => void;
    onProductSelect?: (product: FeedbackProductItem | null) => void;
    fetchProducts?: (params: FetchProductsParams) => Promise<FeedbackProductItem[]>;
}

/** PC 筛选入口，渲染 PC 版 FilterContent */
class PCFeedbackFilter extends React.Component<PCFeedbackFilterProps> {
    render() {
        return <FilterContent {...this.props} />;
    }
}

export default PCFeedbackFilter;
